import $ from 'jquery'
import { isVisible } from '../utils'

const FOCUSABLE_SELECTOR = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
].join(", ")

const isRadio = (el) => el.type === "radio"

const tabStopRadio = (controls, name) => {
  const group = controls.filter((el) => isRadio(el) && el.name === name)
  return group.find((radio) => radio.checked) || group[0]
}

const kModal = {
  class: 'kolide-modal',

  $ModalOverlay: null,
  $ModalWrapper: null,

  content: null,
  trigger: null,

  config: {},
  defaultConfig: {
    href: '',
    launchingUrl: '',
    title: '',
    namespace: '',
    content: '',
    ujs: false,
    ajax: false,
    size: 'small',
    appendTo: 'body',
    autoClose: false,
  },

  modalSelect: (not) => {
    const { namespace } = kModal.config;

    if (namespace) {
      $(`${kModal.class}.${namespace}`);
    }

    return $(`.${kModal.class}`).not(not);
  },

  toggle: () => kModal.modalSelect().toggleClass(`${kModal.class}--active`),

  show: () => {
    kModal.rememberTrigger()
    kModal.modalSelect().removeClass('animate__fadeOut animate__animated hidden')
    kModal.modalSelect().addClass(`${kModal.class}--active`)
    kModal.focusInitial()
  },

  hide: () => {
    kModal.modalSelect('.hidden').last().addClass('animate__fadeOut animate__animated')
    kModal.restoreFocus()
    setTimeout(function(){
      kModal.modalSelect('.hidden').last().removeClass(`${kModal.class}--active`);
      kModal.modalSelect('.hidden').last().addClass(`hidden`);
    }, 500)
  },

  hideAll: () => {
    kModal.$ModalOverlay.removeClass(`${kModal.class}--active`);
  },

  remove: () => {
    kModal.$ModalOverlay.remove();
    kModal.restoreFocus()
  },

  openModal: () => {
    const open = document.querySelectorAll(`.${kModal.class}.${kModal.class}--active:not(.hidden):not(.animate__fadeOut)`)
    return open[open.length - 1]
  },

  // In tab order: visible, not tabindex -1, and only the radio of each group that Tab stops on.
  focusableControls: (modal) => {
    const controls = Array.from(modal.querySelectorAll(FOCUSABLE_SELECTOR))
      .filter((el) => el.tabIndex >= 0 && isVisible(el))

    return controls.filter((el) => !isRadio(el) || el === tabStopRadio(controls, el.name))
  },

  rememberTrigger: () => {
    const active = document.activeElement
    if (active && active !== document.body) kModal.trigger = active
  },

  // As Knox's modal dialog does: the first control in the body, else the first in the footer, else the dialog.
  focusInitial: () => {
    const modal = kModal.openModal()
    if (!modal) return

    const autofocus = modal.querySelector('[autofocus]')
    const control = (autofocus && isVisible(autofocus) && autofocus) ||
      kModal.firstControlIn(modal, `.${kModal.class}__content`) ||
      kModal.firstControlIn(modal, `.${kModal.class}__buttons`) ||
      kModal.focusableControls(modal)[0]

    if (control) {
      control.focus()
    } else {
      kModal.focusDialog(modal)
    }
  },

  firstControlIn: (modal, selector) => {
    const section = modal.querySelector(selector)
    return section && kModal.focusableControls(section)[0]
  },

  focusDialog: (modal) => {
    const dialog = modal.querySelector('[role=dialog], [role=alertdialog]') || modal.firstElementChild
    if (!dialog) return

    if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1')
    dialog.focus()
  },

  restoreFocus: () => {
    const trigger = kModal.trigger
    kModal.trigger = null
    if (trigger?.isConnected) trigger.focus()
  },

  // Tab and Shift+Tab wrap inside the open modal; focus on the dialog itself or behind it moves to its ends.
  trapFocus: (event) => {
    if (event.key !== 'Tab') return

    const modal = kModal.openModal()
    if (!modal) return

    const controls = kModal.focusableControls(modal)
    const first = controls[0]
    const last = controls[controls.length - 1]
    const position = controls.indexOf(document.activeElement)

    if (!first) {
      event.preventDefault()
    } else if (event.shiftKey && position <= 0) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && (position === -1 || position === controls.length - 1)) {
      event.preventDefault()
      first.focus()
    }
  },

  getContent: (href) => {
    $.ajax({
      url: href,
      headers: { 'Kolide-Modal': true, 'X-Requested-With': 'XMLHttpRequest' },
      type: 'GET',
    }).done((data) => {
      kModal.buildContent(data);
    }).fail(() => {
      kModal.remove();
    });
  },

  buildContent: (content) => {
    const { title } = kModal.config;
    const { class: klass, config: { namespace, size } } = kModal;

    const Header = $(`<header class="${kModal.class}__header k-header"><h1></h1></header>`);
    const Content = $(`<div class="${kModal.class}__content"></div>`);

    if (title) {
      Header.find('h1').append(title);
    }

    Content.append(content);

    kModal.content = Content;
    kModal.$ModalOverlay.addClass(`${klass}--active ${namespace}`);
    kModal.$ModalOverlay.append(content);
    kModal.focusInitial();
  },

  buildModal: () => {
    const { class: klass } = kModal;
    const { appendTo } = kModal.config;

    let klasses;
    if (kModal.config.ujs) {
      klasses = `${klass} animate__animated animate__fadeIn animate__faster`
    } else {
      klasses = `${klass}`
    }

    let controllers;
    let actions;
    if (kModal.config.autoClose) {
      controllers = `modal-close modal-auto-close`
      actions = `mousedown->modal-auto-close#closeModal keyup@window->modal-auto-close#keyUpHandler`
    } else {
      controllers = `modal-close`
    }

    kModal.$ModalOverlay = $('<div />', { class: klasses, 'data-controller': controllers, 'data-action': actions, 'data-modal-auto-close-exit-url-value': kModal.config.launchingUrl, 'data-modal-close-exit-url-value': kModal.config.launchingUrl, 'data-modal-auto-close-target': 'container' });
    $(appendTo).append(kModal.$ModalOverlay);
  },

  createBtn: (options) => {
    const { style, content, action } = options;
    const $btn = $('<button>', { class: `button button--${style}` });

    $btn.html(content);
    $btn.off('.kModal').on('click.kModal', (evt) => {
      evt.preventDefault();
      action(evt, $(evt.currentTarget));
    });

    return $btn[0];
  },

  init: (options) => {
    kModal.config = {}; // we need to clear this out between inits
    kModal.config = $.extend({}, kModal.defaultConfig, options);
    kModal.rememberTrigger();

    if ($.contains(document, kModal.modalSelect())) {
      kModal.show();
    } else {
      kModal.buildModal();

      if (typeof kSidebar !== "undefined" && kSidebar.config.ajax) {
        kModal.getContent(kModal.config.href);
      } else {
        kModal.buildContent(kModal.config.content);
      }
    }
  },
};

document.addEventListener('keydown', kModal.trapFocus)

module.exports = kModal;
